(function() {
  define('commons/basicInfoCharts',["jquery", "commons/chartServices"], function($, chartServices) {
    var executeAdvertisersChart, executeAgeChart, executeGenderChart;
    executeAdvertisersChart = function(mediaId, cardId, chartId) {
      var calculateAdvertisersData;
      $.ajax({
        url: TSUrl.ApiUrl + "/Api/Charts/ExpenseBarChartData?mediaId=" + mediaId,
        dataType: "jsonp"
      }).done(function(res) {
        var chartSettings, x;
        if (!((res != null) && res.expenseChartDataPoints.length)) {
          return;
        }
        $(cardId).removeClass("hide");
        x = calculateAdvertisersData(res);
        chartSettings = {
          labelsFormat: "{point.y:,.0f}",
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        };
        return chartServices.renderBarChart(chartId, x, chartSettings);
      });
      return calculateAdvertisersData = function(x) {
        var d, data, i, item, len, ref, value;
        data = [];
        item = {
          name: "Annonsvolym brutto (SEK)",
          colorByPoint: false,
          color: "#7CB5EC",
          data: []
        };
        ref = x.expenseChartDataPoints;
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          value = {
            name: d.advertiser,
            y: d.value
          };
          item.data.push(value);
        }
        data.push(item);
        return data;
      };
    };
    executeGenderChart = function(mediaId, cardId) {
      var calculateGenderData;
      $.ajax({
        url: TSUrl.ApiUrl + "/Api/Charts/GenderBarChartData?MediaId=" + mediaId,
        dataType: "jsonp"
      }).done(function(res) {
        var reachText, x;
        if (!((res != null) && res.dataPoints.length)) {
          return;
        }
        $(cardId).removeClass("hide");
        x = calculateGenderData(res);
        if (res.dataPoints[0].surveyName != null) {
          $(".reach-period").text(res.dataPoints[0].surveyName);
          $(".reach-period").parent().removeClass("hide");
        }
        if (x.totalReach != null) {
          reachText = chartServices.thousandFormat(x.totalReach) + " - ";
          $(".media-total-reach").removeClass("hide").text(reachText);
        }
        $("#female-pie").pieChart({
          barColor: "#ECBB64",
          trackColor: "#f4f5f9",
          lineCap: "square",
          lineWidth: 5,
          rotate: 180,
          percent: x.female,
          onStep: function(from, to, percent) {
            return $(this.element).find(".pie-value").html(Math.round(percent) + "<i>%</i>");
          }
        });
        return $('#male-pie').pieChart({
          barColor: '#806C83',
          trackColor: '#f4f5f9',
          lineCap: 'square',
          lineWidth: 5,
          rotate: 180,
          percent: x.male,
          onStep: function(from, to, percent) {
            return $(this.element).find(".pie-value").html(Math.round(percent) + "<i>%</i>");
          }
        });
      });
      return calculateGenderData = function(x) {
        var femalePercentage, femaleReach, malePercentage, maleReach, sum;
        maleReach = x.dataPoints[0].reach;
        femaleReach = x.dataPoints[1].reach;
        sum = maleReach + femaleReach;
        malePercentage = (maleReach / sum) * 100;
        femalePercentage = (femaleReach / sum) * 100;
        return {
          male: malePercentage,
          female: femalePercentage,
          totalReach: x.dataPoints[0].totalReach
        };
      };
    };
    executeAgeChart = function(mediaId, cardId, chartId) {
      var calculateAgeData;
      $.ajax({
        url: TSUrl.ApiUrl + "/Api/Charts/QuestionBarChartData?MediaId=" + mediaId + "&QuestionType=Age",
        dataType: "jsonp"
      }).done(function(res) {
        var chartSettings, x;
        if (!((res != null) && res.dataPoints.length)) {
          return;
        }
        if ($(cardId).length <= 0) {
          return;
        }
        $(cardId).removeClass("hide");
        x = calculateAgeData(res);
        if (res.dataPoints[0].surveyName != null) {
          $(".reach-period").text(res.dataPoints[0].surveyName);
          $(".reach-period").parent().removeClass("hide");
        }
        chartSettings = {
          labelsFormat: "{point.y:.0f}%",
          yAxis: {
            title: false,
            gridLineColor: 'transparent',
            lineWidth: 0,
            minorGridLineWidth: 0,
            lineColor: 'transparent',
            labels: {
              enabled: false
            },
            minorTickLength: 0,
            tickLength: 0
          }
        };
        return chartServices.renderColumnChart(chartId, x, chartSettings);
      });
      return calculateAgeData = function(x) {
        var d, data, i, item, len, ref, sum, value;
        sum = x.dataPoints.reduce((function(total, age) {
          return total + age.reach;
        }), 0);
        data = [];
        item = {
          name: "Alder",
          colorByPoint: false,
          color: "#7CB5EC",
          data: []
        };
        ref = x.dataPoints.reverse();
        for (i = 0, len = ref.length; i < len; i++) {
          d = ref[i];
          value = {
            name: d.optionName,
            y: (d.reach / sum) * 100
          };
          item.data.push(value);
        }
        data.push(item);
        return data;
      };
    };
    return {
      executeAdvertisersChart: executeAdvertisersChart,
      executeGenderChart: executeGenderChart,
      executeAgeChart: executeAgeChart
    };
  });

}).call(this);

//# sourceMappingURL=basicInfoCharts.js.map
;
